(() => {
  const root = document.querySelector('[data-create-page]');
  if (!root) return;

  const MIN_PHOTOS = 4;
  const MAX_PHOTOS = 10;
  const MAX_BYTES = 10 * 1024 * 1024;
  const CONSENT_VERSION = 'photo-processing-v1';
  const GENERATION_PRESET = 'micky';
  const SUBJECT_MAP = {
    Female: 'woman',
    Male: 'man',
    Dog: 'dog',
    Cat: 'cat',
  };
  const CHECK_SVG =
    '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.4 6.2 4.8 8.7 9.6 3.4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  const calendarOverlayUrl = root.dataset.calendarOverlay || '';
  const apiBase = (root.dataset.apiBase || '').replace(/\/$/, '');
  const storeKey = root.dataset.storeKey || '';
  const routes = typeof Theme !== 'undefined' && Theme.routes ? Theme.routes : {};
  const cartAddUrl = routes.cart_add_url || root.dataset.cartAdd || '/cart/add.js';

  let catalog = { sizes: {}, stands: {} };
  try {
    catalog = JSON.parse(root.querySelector('[data-create-catalog]')?.textContent || '{}');
  } catch (error) {
    console.warn('Create page catalog could not be parsed', error);
  }

  let firefighterGalleries = {};
  try {
    firefighterGalleries = JSON.parse(root.querySelector('[data-firefighter-galleries]')?.textContent || '{}');
  } catch (error) {
    console.warn('Firefighter galleries could not be parsed', error);
  }

  let themeRoster = [];
  try {
    themeRoster = JSON.parse(root.querySelector('[data-firefighter-roster]')?.textContent || '[]');
  } catch (error) {
    console.warn('Firefighter roster could not be parsed', error);
  }

  let mockupRenders = {};
  try {
    mockupRenders = JSON.parse(root.querySelector('[data-mockup-renders]')?.textContent || '{}');
  } catch (error) {
    console.warn('Mockup renders could not be parsed', error);
  }

  const FEATURED_FIREFIGHTER_COUNT = 4;
  const presetRow = root.querySelector('[data-firefighter-row]');
  const firefighterGrid = root.querySelector('[data-firefighter-grid]');
  const firefighterDialog = root.querySelector('[data-dialog="firefighters"]');
  const photosInput = root.querySelector('[data-photos-input]');
  const consentInput = root.querySelector('[data-photo-consent]');
  const consentPanel = root.querySelector('[data-photo-consent-panel]');
  const consentError = root.querySelector('[data-consent-error]');
  const dropzone = root.querySelector('[data-dropzone]');
  const thumbs = root.querySelector('[data-photo-thumbs]');
  const uploadCount = root.querySelector('[data-upload-count]');
  const addButton = root.querySelector('[data-add-to-cart]');
  const statusEl = root.querySelector('[data-status]');
  const galleryMain = root.querySelector('[data-gallery-main]');
  const galleryThumbs = root.querySelector('[data-gallery-thumbs]');
  const sizeLabel = root.querySelector('[data-size-label]');
  const qtyInput = root.querySelector('[data-qty]');
  const printStep = root.querySelector('[data-print-step]');
  const printStepNum = root.querySelector('[data-print-step-num]');
  const standStep = root.querySelector('[data-stand-step]');
  const standStepNum = root.querySelector('[data-stand-step-num]');
  const includesPrint = root.querySelector('[data-includes-print]');
  const uploadStepNum = root.querySelector('[data-upload-step-num]');
  const uploadStep = root.querySelector('[data-upload-step]');
  const uploadError = root.querySelector('[data-upload-error]');
  const subjectStep = root.querySelector('[data-subject-step]');
  const subjectError = root.querySelector('[data-subject-error]');
  const cropDialog = root.querySelector('[data-dialog="crop"]');
  const cropStage = root.querySelector('[data-crop-stage]');
  const cropImageEl = root.querySelector('[data-crop-image]');
  const cropBoxEl = root.querySelector('[data-crop-box]');

  const CROP_MIN_BOX = 48;
  const CROP_MAX_EDGE = 4096;
  const CROP_PAD = 16;

  /** @type {{ file: File, previewUrl: string, id: number|string|null, verdict: string, message: string, role: string, uploading: boolean, deleting: boolean }[]} */
  let photos = [];
  let session = null;
  let subjectChosenByUser = false;
  let subjectPatchFlight = null;
  let presetPatchFlight = null;
  /** @type {{ consent_given_at: string, consent_version: string, consent_wording: string, session_id: string } | null} */
  let photoConsent = null;
  let sessionRequest = 0;
  let uploadGeneration = 0;
  let sessionBusy = false;
  let checkoutBusy = false;
  let uploadsRunning = false;
  let sessionInFlight = null;
  let sessionInFlightKey = '';
  let cropIndex = -1;
  const cropState = {
    image: null,
    objectUrl: '',
    scale: 1,
    fitScale: 1,
    panX: 0,
    panY: 0,
    box: { x: 0, y: 0, w: 0, h: 0 },
    mode: 'none',
    lastX: 0,
    lastY: 0,
    startBox: null,
    pointers: new Map(),
    pinchDist: 0,
    pinchScale: 1,
    needsFit: false,
  };

  const apiUrl = (path) => apiBase + path;

  const apiHeaders = (extra = {}) => {
    const headers = { Accept: 'application/json', ...extra };
    if (storeKey) headers['X-Store-Key'] = storeKey;
    return headers;
  };

  const setStatus = (text, isError = false) => {
    if (!statusEl) return;
    statusEl.textContent = text;
    statusEl.classList.toggle('create-page__status--error', isError);
  };

  function statusIsPhotoFeedback() {
    if (!statusEl) return false;
    if (statusEl.classList.contains('create-page__status--error')) return true;
    return statusEl.textContent === ACCESSORY_NOTE;
  }

  function setSubjectInvalid(invalid) {
    subjectStep?.classList.toggle('is-invalid', invalid);
    const group = subjectStep?.querySelector('[data-option-group="subject"]');
    if (group) group.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    if (subjectError) subjectError.hidden = !invalid;
    if (invalid) subjectStep?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function setUploadInvalid(invalid) {
    uploadStep?.classList.toggle('is-invalid', invalid);
    dropzone?.setAttribute('aria-invalid', invalid ? 'true' : 'false');
    if (uploadError) uploadError.hidden = !invalid;
    if (!invalid) return;
    if (statusEl?.textContent === `Upload ${MIN_PHOTOS}–${MAX_PHOTOS} photos.`) setStatus('');
    uploadStep?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  const ACCESSORY_NOTE = 'Clearer photos without hats or sunglasses give a stronger portrait.';
  const OTHER_PHOTO_ISSUE = /\b(blur(?:ry|red)?|extra people|multiple people|other people|another person|group photo|low quality|poor lighting|black and white|black & white|sepia|filters?|no face|not a face|face not visible|cropped|extreme angle|too dark|overexposed)\b/i;

  function isAccessoryOnly(photo) {
    const message = String(photo?.message || '').trim();
    if (!message) return false;
    const mentionsHatOrGlasses = /\b(sun\s*glasses?|hats?|large glasses)\b/i.test(message) || /glasses\s+covering/i.test(message);
    const coveringFace = /\b(hat|sunglasses|glasses)\b/i.test(message) && /covering the face/i.test(message);
    if (!mentionsHatOrGlasses && !coveringFace) return false;
    return !OTHER_PHOTO_ISSUE.test(message);
  }

  function isHardReject(photo) {
    return (photo.verdict === 'poor' || photo.verdict === 'rejected') && !isAccessoryOnly(photo);
  }

  function displayVerdict(photo) {
    if (isAccessoryOnly(photo) && (photo.verdict === 'poor' || photo.verdict === 'rejected')) return 'warning';
    return photo.verdict || '';
  }

  function photoFeedbackCopy(photo) {
    if (photo?.verdict === 'good') return '';
    const feedback = String(photo?.message || '').trim();
    const body = /^great photo\.?$/i.test(feedback) ? '' : feedback;
    if (!body) return '';
    if (!photo?.verdict || isAccessoryOnly(photo)) return body;
    return [body, 'Upload a different photo.'].filter(Boolean).join(' ');
  }

  function isUsableFace(photo) {
    if (!/^face/i.test(photo.role || '')) return false;
    if (photo.verdict === 'good' || photo.verdict === 'warning') return true;
    return (photo.verdict === 'poor' || photo.verdict === 'rejected') && isAccessoryOnly(photo);
  }

  function bestCustomerPhoto() {
    const rank = (photo) => {
      if (photo.verdict === 'good') return 3;
      if (photo.verdict === 'warning') return 2;
      return 1;
    };
    const faces = photos.filter((photo) => photo.file && isUsableFace(photo));
    const pool = faces.length ? faces : photos.filter((photo) => photo.file);
    return pool.sort((left, right) => rank(right) - rank(left))[0] || null;
  }

  function canvasToJpegBlob(canvas, quality) {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => resolve(blob), 'image/jpeg', quality);
    });
  }

  async function customerPhotoFile() {
    const photo = bestCustomerPhoto();
    if (!photo?.file) return null;
    let bitmap;
    try {
      try {
        bitmap = await createImageBitmap(photo.file, { imageOrientation: 'from-image' });
      } catch {
        bitmap = await createImageBitmap(photo.file);
      }
      const size = 96;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const context = canvas.getContext('2d', { alpha: false });
      if (!context) return null;
      context.fillStyle = '#ffffff';
      const scale = Math.max(size / bitmap.width, size / bitmap.height);
      const width = bitmap.width * scale;
      const height = bitmap.height * scale;
      context.drawImage(bitmap, (size - width) / 2, (size - height) / 2, width, height);
      const blob = await canvasToJpegBlob(canvas, 0.72);
      if (!blob?.size) return null;
      return new File([blob], 'photo.jpg', { type: 'image/jpeg' });
    } catch (error) {
      console.warn('Customer photo preview could not be prepared', error);
      return null;
    } finally {
      bitmap?.close?.();
    }
  }

  function isUsableFullBody(photo) {
    if (photo.role !== 'full_body') return false;
    if (photo.verdict === 'good' || photo.verdict === 'warning') return true;
    return (photo.verdict === 'poor' || photo.verdict === 'rejected') && isAccessoryOnly(photo);
  }

  function photoCheckoutMessage() {
    if (photos.some((photo) => photo.uploading || photo.deleting)) return '';
    if (photos.length < MIN_PHOTOS) return `Upload ${MIN_PHOTOS}–${MAX_PHOTOS} photos.`;
    if (photos.some((photo) => !photo.id)) return '';
    if (photos.filter(isUsableFace).length < 2) {
      return 'Please upload two clear photos of the face from different angles.';
    }
    if (!photos.some(isUsableFullBody)) {
      return 'Upload at least one full-body photo for the results to turn out.';
    }
    if (photos.some(isHardReject)) {
      return 'Replace the photos marked below, then try again.';
    }
    return '';
  }

  function photoAdvisoryNote() {
    if (photoCheckoutMessage()) return '';
    if (photos.some((photo) => photo.uploading || photo.deleting)) return '';
    if (photos.length < MIN_PHOTOS || photos.some((photo) => !photo.id)) return '';
    return photos.some(isAccessoryOnly) ? ACCESSORY_NOTE : '';
  }

  const selectedSubjectValue = () => SUBJECT_MAP[selectedSubject()] || '';
  const maxPhotoCount = () => {
    const fromSession = Number(session?.max_photos);
    if (fromSession > 0) return Math.min(fromSession, MAX_PHOTOS);
    return MAX_PHOTOS;
  };

  const selectedButton = (group) =>
    root.querySelector(`[data-option-group="${group}"] [aria-pressed="true"]`);

  const selectedSize = () => selectedButton('size')?.dataset.size || 'magnet';
  const selectedStand = () => selectedButton('stand')?.dataset.stand || 'none';
  const selectedPackage = () =>
    root.querySelector('[data-package-option]:checked')?.value === 'digital' ? 'digital' : 'print';
  const selectedSubject = () => selectedButton('subject')?.dataset.option || '';
  let allFirefighters = themeRoster.slice();
  let selectedFirefighter = {
    slug: themeRoster[0]?.slug || 'micky',
    name: themeRoster[0]?.name || 'Micky',
  };
  const selectedPreset = () => selectedFirefighter.slug || '';
  const selectedFirefighterName = () => selectedFirefighter.name || '';
  const quantity = () => Math.max(1, Number(qtyInput?.value) || 1);
  const CUSTOMER_ERROR = 'Something went wrong. Please try again.';
  const DIGITAL_UNAVAILABLE = 'Digital Only is unavailable right now.';

  let availablePresetSlugs = new Set([GENERATION_PRESET]);

  function presetIsAvailable(slug) {
    if (!availablePresetSlugs) return true;
    return availablePresetSlugs.has(slug);
  }

  function customerError(error) {
    console.error(error);
    const wrapped = new Error(CUSTOMER_ERROR);
    wrapped.cause = error;
    return wrapped;
  }

  function isAdminMessage(message) {
    return /theme settings|physical product|not configured|cors|store key|not linked/i.test(String(message || ''));
  }

  function checkoutStatusMessage(error) {
    console.error('Create your own failed', error?.cause || error, error?.body || error?.status || '');
    const message = error?.message || '';
    if (!message || message === CUSTOMER_ERROR || error?.network || isAdminMessage(message)) return CUSTOMER_ERROR;
    return message;
  }

  function digitalOffer() {
    const product = catalog.digital;
    if (!product?.id || product.requiresShipping) return null;
    return product;
  }

  function syncAddButton() {
    if (!addButton) return;
    const blocked = selectedPackage() === 'digital' && !digitalOffer();
    addButton.disabled = checkoutBusy || blocked;
    const note = root.querySelector('[data-digital-unavailable]');
    if (note) note.hidden = !blocked;
    const label = addButton.querySelector('.create-page__generate-label');
    if (label) label.textContent = blocked ? 'Unavailable' : 'Add to cart';
  }

  function pressStand(standKey) {
    const options = root.querySelectorAll('[data-option-group="stand"] [data-option]');
    const known = [...options].some((el) => el.dataset.stand === standKey);
    const next = known ? standKey : 'none';
    options.forEach((el) => {
      el.setAttribute('aria-pressed', el.dataset.stand === next ? 'true' : 'false');
    });
  }

  function renumberSteps() {
    const digital = root.dataset.package === 'digital';
    const standsAllowed = !digital && catalog.sizes?.[root.dataset.size]?.stands !== false;
    let step = 4;
    if (printStepNum) printStepNum.textContent = `${step}.`;
    if (!digital) step += 1;
    if (standStepNum) standStepNum.textContent = `${step}.`;
    if (standsAllowed) step += 1;
    if (uploadStepNum) uploadStepNum.textContent = `${step}.`;
  }

  function selectedOffer() {
    if (selectedPackage() === 'digital') {
      const input = root.querySelector('[data-package-option="digital"]');
      return {
        label: input?.dataset.priceLabel || '',
      };
    }
    const sizeButton = selectedButton('size');
    return {
      label: sizeButton?.dataset.priceLabel || '',
    };
  }

  function showPlaquePrice() {
    const offer = selectedOffer();
    root.querySelectorAll('[data-price-now]').forEach((el) => {
      if (offer.label) el.textContent = offer.label;
    });
  }

  function applyPackage(packageKey) {
    const digital = packageKey === 'digital';
    root.dataset.package = digital ? 'digital' : 'print';
    if (includesPrint) {
      if (digital) includesPrint.setAttribute('aria-hidden', 'true');
      else includesPrint.removeAttribute('aria-hidden');
    }
    if (digital) {
      printStep?.setAttribute('inert', '');
      printStep?.setAttribute('aria-hidden', 'true');
      standStep?.setAttribute('inert', '');
      standStep?.setAttribute('aria-hidden', 'true');
      if (sizeLabel) sizeLabel.hidden = true;
      renumberSteps();
      showPlaquePrice();
      refreshMockup();
      syncAddButton();
      return;
    }
    printStep?.removeAttribute('inert');
    printStep?.removeAttribute('aria-hidden');
    if (sizeLabel) sizeLabel.hidden = false;
    applySize(selectedSize());
    syncAddButton();
  }

  function applySize(sizeKey) {
    const previousSize = root.dataset.size;
    const size = catalog.sizes?.[sizeKey];
    root.dataset.size = sizeKey;
    const digital = root.dataset.package === 'digital';
    if (sizeLabel) {
      sizeLabel.textContent = size?.label || '';
      sizeLabel.hidden = digital;
    }
    const standsAllowed = !digital && size?.stands !== false;

    if (standsAllowed) {
      standStep?.removeAttribute('inert');
      standStep?.removeAttribute('aria-hidden');
      if (previousSize !== sizeKey || !selectedButton('stand')) pressStand('clear');
    } else if (!digital) {
      standStep?.setAttribute('inert', '');
      standStep?.setAttribute('aria-hidden', 'true');
      pressStand('none');
    }

    renumberSteps();
    showPlaquePrice();
    root.dataset.stand = mockupStandKey();
    refreshMockup();
  }

  function wrapApiError(error) {
    if (error instanceof TypeError) {
      console.error(error);
      const wrapped = new Error(CUSTOMER_ERROR);
      wrapped.network = true;
      return wrapped;
    }
    return error;
  }

  async function jsonFetch(path, options = {}) {
    const headers = apiHeaders(options.headers || {});
    if (options.body && !(options.body instanceof FormData) && !headers['Content-Type']) {
      headers['Content-Type'] = 'application/json';
    }
    let response;
    try {
      response = await fetch(apiUrl(path), { ...options, headers });
    } catch (error) {
      throw wrapApiError(error);
    }
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      console.error('Generation request failed', { path, status: response.status, body: data });
      const error = new Error(data.message || `Request failed (${response.status})`);
      error.status = response.status;
      error.body = data;
      throw error;
    }
    return data;
  }

  function unwrapPayload(data) {
    if (!data || typeof data !== 'object') return data;
    if (
      data.id ||
      data.photo ||
      data.ready_for_checkout !== undefined ||
      data.blocking_reason !== undefined ||
      Array.isArray(data.photos)
    ) {
      return data;
    }
    if (data.data && typeof data.data === 'object' && !Array.isArray(data.data)) {
      return data.data;
    }
    return data;
  }

  const themeFirefighterImages = {};
  themeRoster.forEach((preset) => {
    if (preset.image) themeFirefighterImages[preset.slug] = preset.image;
  });

  function firefighterImage(preset) {
    if (!preset) return '';
    return (
      themeFirefighterImages[preset.slug] ||
      preset.image ||
      preset.image_url ||
      preset.thumbnail ||
      preset.photo_url ||
      ''
    );
  }

  function imageForSlug(slug) {
    const preset = allFirefighters.find((item) => item.slug === slug);
    return firefighterImage(preset || { slug });
  }

  function createFirefighterButton(preset, { pressed = false, viewMore = false } = {}) {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'create-page__firefighter';
    button.setAttribute('aria-pressed', pressed ? 'true' : 'false');

    const imageUrl = firefighterImage(preset);
    if (viewMore) {
      button.dataset.viewMore = '';
      button.dataset.openDialog = 'firefighters';
      if (imageUrl) button.dataset.teaserImage = imageUrl;
    } else {
      button.dataset.preset = preset.slug;
      if (imageUrl) button.dataset.image = imageUrl;
      if (availablePresetSlugs && !availablePresetSlugs.has(preset.slug)) {
        button.disabled = true;
      }
    }

    const media = document.createElement('span');
    media.className = 'create-page__firefighter-media';
    if (imageUrl) {
      const img = document.createElement('img');
      img.src = imageUrl;
      img.alt = viewMore ? '' : preset.name || '';
      media.appendChild(img);
    } else {
      media.textContent = (preset.name || preset.slug || '?').charAt(0);
    }

    const check = document.createElement('span');
    check.className = 'create-page__firefighter-check';
    check.setAttribute('aria-hidden', 'true');
    check.innerHTML = CHECK_SVG;

    const name = document.createElement('span');
    name.className = 'create-page__firefighter-name';
    name.textContent = viewMore ? 'View More' : preset.name || preset.slug;

    button.append(media, check, name);
    return button;
  }

  function featuredSlugs() {
    return allFirefighters.slice(0, FEATURED_FIREFIGHTER_COUNT).map((preset) => preset.slug);
  }

  function syncViewMoreTile(inFeatured) {
    const viewMore = presetRow?.querySelector('[data-view-more]');
    if (!viewMore) return;
    viewMore.setAttribute('aria-pressed', inFeatured ? 'false' : 'true');
    const img = viewMore.querySelector('img');
    if (!img) return;
    const teaser = viewMore.dataset.teaserImage || '';
    if (inFeatured) {
      if (teaser) img.src = teaser;
      img.alt = '';
      return;
    }
    const selectedImage = imageForSlug(selectedFirefighter.slug);
    if (selectedImage) img.src = selectedImage;
    img.alt = selectedFirefighter.name || '';
  }

  function syncFirefighterSelection() {
    const slug = selectedFirefighter.slug;
    const inFeatured = featuredSlugs().includes(slug);

    presetRow?.querySelectorAll('[data-preset]').forEach((el) => {
      el.setAttribute('aria-pressed', el.dataset.preset === slug ? 'true' : 'false');
    });
    syncViewMoreTile(inFeatured);
    firefighterGrid?.querySelectorAll('[data-preset]').forEach((el) => {
      el.setAttribute('aria-pressed', el.dataset.preset === slug ? 'true' : 'false');
    });
  }

  function selectFirefighterFromButton(button, { closeDialog = false } = {}) {
    if (button?.disabled) return;
    const slug = button?.dataset.preset;
    if (!slug) return;
    if (availablePresetSlugs && !availablePresetSlugs.has(slug)) return;
    const preset = allFirefighters.find((item) => item.slug === slug);
    const name =
      preset?.name ||
      button.querySelector('.create-page__firefighter-name')?.textContent?.trim() ||
      slug;
    selectedFirefighter = { slug, name };
    syncFirefighterSelection();
    showGallery(slug);
    if (closeDialog) firefighterDialog?.close();
    if (selectedSubjectValue()) {
      ensureSession().catch((error) => setStatus(error.message, true));
    }
  }

  function mergePresets(apiPresets) {
    const bySlug = new Map();
    apiPresets.forEach((preset) => {
      if (preset?.slug) bySlug.set(preset.slug, preset);
    });

    return themeRoster.map((theme) => {
      const api = bySlug.get(theme.slug) || {};
      return {
        slug: theme.slug,
        name: theme.name || api.name || theme.slug,
        image: theme.image || firefighterImage({ ...api, slug: theme.slug }),
        image_url: api.image_url,
        thumbnail: api.thumbnail,
        photo_url: api.photo_url,
      };
    });
  }

  function renderFirefighters(presets) {
    if (!presets.length) return;
    allFirefighters = presets;
    if (!featuredSlugs().includes(selectedFirefighter.slug)) {
      const stillListed = presets.some((preset) => preset.slug === selectedFirefighter.slug);
      if (!stillListed) {
        selectedFirefighter = {
          slug: presets[0].slug,
          name: presets[0].name || presets[0].slug,
        };
      }
    } else {
      const current = presets.find((preset) => preset.slug === selectedFirefighter.slug);
      if (current?.name) selectedFirefighter.name = current.name;
    }

    if (presetRow) {
      presetRow.innerHTML = '';
      const featured = presets.slice(0, FEATURED_FIREFIGHTER_COUNT);
      featured.forEach((preset) => {
        presetRow.appendChild(
          createFirefighterButton(preset, { pressed: selectedFirefighter.slug === preset.slug })
        );
      });
      const teaser = presets[FEATURED_FIREFIGHTER_COUNT] || presets[presets.length - 1];
      const overflowSelected = !featured.some((preset) => preset.slug === selectedFirefighter.slug);
      presetRow.appendChild(
        createFirefighterButton(teaser, { viewMore: true, pressed: overflowSelected })
      );
      syncViewMoreTile(!overflowSelected);
    }

    if (firefighterGrid) {
      firefighterGrid.innerHTML = '';
      presets.forEach((preset) => {
        firefighterGrid.appendChild(
          createFirefighterButton(preset, { pressed: selectedFirefighter.slug === preset.slug })
        );
      });
    }

    showGallery(selectedFirefighter.slug || presets[0]?.slug || 'micky');
  }

  function bindFirefighterClicks() {
    if (presetRow && presetRow.dataset.galleryBound !== 'true') {
      presetRow.dataset.galleryBound = 'true';
      presetRow.addEventListener('click', (event) => {
        if (event.target.closest('[data-view-more]')) {
          firefighterDialog?.showModal();
          return;
        }
        const button = event.target.closest('[data-preset]');
        if (!button || !presetRow.contains(button)) return;
        selectFirefighterFromButton(button);
      });
    }
    if (firefighterGrid && firefighterGrid.dataset.galleryBound !== 'true') {
      firefighterGrid.dataset.galleryBound = 'true';
      firefighterGrid.addEventListener('click', (event) => {
        const button = event.target.closest('[data-preset]');
        if (!button || !firefighterGrid.contains(button)) return;
        selectFirefighterFromButton(button, { closeDialog: true });
      });
    }
  }

  function exampleAlt(subject) {
    if (subject === 'female') return 'Personalised firefighter example with female customer';
    if (subject === 'male') return 'Personalised firefighter example with male customer';
    if (subject === 'dog') return 'Personalised firefighter example with dog';
    if (subject === 'cat') return 'Personalised firefighter example with cat';
    return 'Personalised firefighter example';
  }

  function galleryItemsFor(slug) {
    const key = String(slug || '').toLowerCase();
    const raw = firefighterGalleries[key] || firefighterGalleries[slug] || [];
    const items = (Array.isArray(raw) ? raw : [])
      .map((entry) => {
        if (typeof entry === 'string') return { src: entry, thumb: entry, subject: '' };
        const src = entry?.src || entry?.thumb || '';
        return { src, thumb: entry?.thumb || src, subject: entry?.subject || '' };
      })
      .filter((item) => item.src && item.subject !== 'dog' && item.subject !== 'cat');
    if (items.length) return items;
    const fallback = imageForSlug(slug);
    return fallback ? [{ src: fallback, thumb: fallback, subject: '' }] : [];
  }

  let galleryItems = [];
  const preloadedGallerySrc = new Set();

  function preloadGallerySrc(src) {
    if (!src || preloadedGallerySrc.has(src)) return;
    preloadedGallerySrc.add(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  function preloadAround(index) {
    const count = galleryItems.length;
    if (!count) return;
    [-1, 0, 1].forEach((delta) => {
      const item = galleryItems[(index + delta + count) % count];
      preloadGallerySrc(item?.src);
    });
  }

  function mockupStandKey() {
    const size = catalog.sizes?.[selectedSize()];
    if (size?.stands === false) return 'none';
    return selectedStand() || 'none';
  }

  function mockupPair() {
    if (root.dataset.package === 'digital') return null;
    const sizeMap = mockupRenders[selectedSize()] || {};
    return sizeMap[mockupStandKey()] || sizeMap.none || null;
  }

  function mockupPlate(url, className) {
    const layer = document.createElement('div');
    layer.className = className;
    layer.style.backgroundImage = `url("${url}")`;
    return layer;
  }

  function calendarOverlayImage() {
    if (!calendarOverlayUrl) return null;
    const overlay = document.createElement('img');
    overlay.className = 'create-page__calendar-overlay';
    overlay.src = calendarOverlayUrl;
    overlay.alt = '';
    overlay.setAttribute('aria-hidden', 'true');
    return overlay;
  }

  function withCalendarArt(design, overlay) {
    if (!overlay) return design;
    const art = document.createElement('div');
    art.className = 'create-page__mockup-art';
    art.appendChild(design);
    art.appendChild(overlay);
    return art;
  }

  function buildMockupNode(designSrc, alt = '', options = {}) {
    const wrap = document.createElement('div');
    wrap.className = 'create-page__mockup';
    const overlay = options.overlay ? calendarOverlayImage() : null;
    const pair = mockupPair();
    if (!pair) {
      const img = document.createElement('img');
      img.src = designSrc;
      img.alt = alt;
      wrap.appendChild(withCalendarArt(img, overlay));
      return wrap;
    }
    wrap.classList.add('create-page__mockup--print');
    wrap.dataset.edge = 'inset';
    const plate = mockupPlate(pair.render, 'create-page__mockup-plate');
    const mat = document.createElement('div');
    mat.className = 'create-page__mockup-mat';
    const design = document.createElement('img');
    design.className = 'create-page__mockup-design';
    design.src = designSrc;
    design.alt = alt;
    design.width = 1000;
    design.height = 1400;
    mat.appendChild(withCalendarArt(design, overlay));
    plate.appendChild(mat);
    wrap.appendChild(mockupPlate(pair.mask, 'create-page__mockup-mask'));
    wrap.appendChild(plate);
    return wrap;
  }

  function refreshMockup() {
    const active =
      galleryThumbs?.querySelector('.create-page__thumb[aria-pressed="true"]') ||
      galleryThumbs?.querySelector('.create-page__thumb');
    if (!active?.dataset.src) return;
    selectGalleryThumb(active);
  }

  function setGalleryImage(src, activeButton) {
    if (!src || !galleryMain) return;
    const subject = activeButton?.dataset.subject || '';
    const alt = exampleAlt(subject);
    galleryThumbs?.querySelectorAll('.create-page__thumb').forEach((el) => el.setAttribute('aria-pressed', 'false'));
    if (activeButton) activeButton.setAttribute('aria-pressed', 'true');
    if (subject) galleryMain.dataset.subject = subject;
    else delete galleryMain.dataset.subject;
    galleryMain.innerHTML = '';
    const firstExample = galleryThumbs?.querySelector('.create-page__thumb');
    const node = buildMockupNode(src, alt, { overlay: Boolean(activeButton) && activeButton === firstExample });
    const image = node.querySelector('.create-page__mockup-design') || node.querySelector('img:not(.create-page__calendar-overlay)');
    if (image && subject) image.dataset.subject = subject;
    galleryMain.appendChild(node);
  }

  function laidOutThumbs() {
    return [...(galleryThumbs?.querySelectorAll('.create-page__thumb') || [])].filter(
      (el) => getComputedStyle(el).display !== 'none'
    );
  }

  function thumbMotion(behavior) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 'auto';
    return behavior || 'smooth';
  }

  function thumbStride(thumbs) {
    if (!thumbs?.length) return 0;
    if (thumbs.length >= 2) {
      const delta = thumbs[1].getBoundingClientRect().left - thumbs[0].getBoundingClientRect().left;
      if (delta > 0) return delta;
    }
    const gap = parseFloat(getComputedStyle(galleryThumbs).columnGap) || 0;
    return thumbs[0].getBoundingClientRect().width + gap;
  }

  let frameWidth = -1;

  function syncGalleryFrame() {
    if (!galleryMain) return false;
    const gallery = galleryMain.closest('.create-page__gallery');
    const width = galleryMain.getBoundingClientRect().width;
    if (!gallery || width <= 0) return false;
    if (Math.abs(width - frameWidth) < 0.5) return false;
    frameWidth = width;
    gallery.style.setProperty('--create-frame-width', `${width}px`);
    fitThumbWindow();
    return true;
  }

  function fitThumbWindow() {
    if (!galleryThumbs) return;
    const viewport = galleryThumbs.closest('.create-page__thumbs-viewport');
    if (!viewport) return;
    const available = viewport.clientWidth;
    galleryThumbs.style.width = 'max-content';
    const thumbs = laidOutThumbs();
    if (!thumbs.length || available <= 0) {
      galleryThumbs.style.width = '';
      return;
    }
    const thumbWidth = thumbs[0].getBoundingClientRect().width;
    const stride = thumbs.length > 1
      ? thumbs[1].getBoundingClientRect().left - thumbs[0].getBoundingClientRect().left
      : thumbWidth;
    const gap = Math.max(0, stride - thumbWidth);
    if (stride <= 0) return;
    let count = Math.floor((available + gap + 0.01) / stride);
    count = Math.max(1, Math.min(count, thumbs.length));
    let windowWidth = count * stride - gap;
    if (windowWidth > available + 0.5) {
      count = Math.max(1, count - 1);
      windowWidth = count * stride - gap;
    }
    galleryThumbs.style.width = `${Math.max(thumbWidth, windowWidth)}px`;
    galleryThumbs.dataset.visibleCount = String(count);
  }

  function scrollThumbIntoView(thumb, options = {}) {
    if (!galleryThumbs || !thumb || galleryThumbs.clientWidth === 0) return;
    const thumbs = laidOutThumbs();
    const index = thumbs.indexOf(thumb);
    const stride = thumbStride(thumbs);
    if (index < 0 || stride <= 0) return;
    const viewCount = Math.max(1, Number(galleryThumbs.dataset.visibleCount) || 1);
    const maxStart = Math.max(0, thumbs.length - viewCount);
    const advance = options.advance || 0;
    let start = Math.round(galleryThumbs.scrollLeft / stride);
    if (advance && index >= start && index < start + viewCount) {
      const nudged = Math.min(maxStart, Math.max(0, start + advance));
      if (index >= nudged && index < nudged + viewCount) start = nudged;
    }
    if (index < start) start = index;
    else if (index > start + viewCount - 1) start = index - viewCount + 1;
    start = Math.min(maxStart, Math.max(0, start));
    const left = start * stride;
    if (Math.abs(galleryThumbs.scrollLeft - left) < 1) return;
    galleryThumbs.scrollTo({ left, behavior: thumbMotion(options.behavior) });
  }

  function selectGalleryThumb(button, options = {}) {
    if (!button) return;
    const thumbs = [...(galleryThumbs?.querySelectorAll('.create-page__thumb') || [])];
    const index = thumbs.indexOf(button);
    setGalleryImage(button.dataset.src, button);
    scrollThumbIntoView(button, options);
    if (index >= 0) preloadAround(index);
  }

  function stepGallery(delta) {
    const thumbs = laidOutThumbs();
    if (!thumbs.length) return;
    const current = thumbs.findIndex((el) => el.getAttribute('aria-pressed') === 'true');
    const index = current < 0 ? (delta > 0 ? 0 : thumbs.length - 1) : (current + delta + thumbs.length) % thumbs.length;
    selectGalleryThumb(thumbs[index], { advance: delta });
  }

  function showGallery(slug) {
    galleryItems = galleryItemsFor(slug);
    if (!galleryThumbs) return;

    galleryThumbs.innerHTML = '';
    galleryThumbs.scrollTo({ left: 0, behavior: 'instant' });

    if (!galleryItems.length) {
      if (galleryMain) {
        delete galleryMain.dataset.subject;
        galleryMain.innerHTML = '';
        const placeholder = document.createElement('div');
        placeholder.className = 'create-page__gallery-placeholder';
        placeholder.textContent = (selectedFirefighter.name || slug || '?').charAt(0);
        galleryMain.appendChild(placeholder);
      }
      return;
    }

    galleryItems.forEach((item, index) => {
      const button = document.createElement('button');
      const alt = exampleAlt(item.subject);
      button.type = 'button';
      button.className = 'create-page__thumb';
      button.dataset.src = item.src;
      button.dataset.thumb = item.thumb;
      if (item.subject) button.dataset.subject = item.subject;
      button.setAttribute('aria-label', alt);
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      const img = document.createElement('img');
      img.src = item.thumb;
      img.alt = alt;
      img.decoding = 'async';
      img.loading = index < 5 ? 'eager' : 'lazy';
      button.appendChild(img);
      if (index === 0) {
        const overlay = calendarOverlayImage();
        if (overlay) button.appendChild(overlay);
      }
      button.addEventListener('click', () => selectGalleryThumb(button));
      galleryThumbs.appendChild(button);
    });

    const firstThumb = galleryThumbs.querySelector('.create-page__thumb');
    fitThumbWindow();
    selectGalleryThumb(firstThumb, { behavior: 'auto' });
    requestAnimationFrame(() => {
      fitThumbWindow();
      const active = galleryThumbs.querySelector('.create-page__thumb[aria-pressed="true"]');
      if (active) scrollThumbIntoView(active, { behavior: 'auto' });
    });
  }

  function applyAvailablePresets() {
    if (!availablePresetSlugs) return;

    root.querySelectorAll('[data-preset]').forEach((button) => {
      const slug = button.dataset.preset;
      button.hidden = false;
      button.disabled = !slug || !availablePresetSlugs.has(slug);
    });
  }

  async function loadPresets() {
    if (!apiBase || !storeKey) {
      applyAvailablePresets();
      return;
    }
    try {
      const data = await jsonFetch('/api/generation-presets');
      const presets = data.data || [];
      availablePresetSlugs = new Set(presets.map((preset) => preset.slug).filter(Boolean));
      applyAvailablePresets();
    } catch (error) {
      console.warn('Firefighter presets could not be loaded', error);
      applyAvailablePresets();
    }
  }

  function consentWording() {
    return (root.querySelector('[data-consent-wording]')?.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function hasUploadConsent() {
    return Boolean(consentInput?.checked && photoConsent?.consent_given_at);
  }

  function consentPayload() {
    if (!photoConsent?.consent_given_at) return null;
    return {
      consent_given_at: photoConsent.consent_given_at,
      consent_version: photoConsent.consent_version,
      consent_wording: photoConsent.consent_wording,
    };
  }

  function clearConsentError() {
    if (consentError) consentError.hidden = true;
    consentInput?.setAttribute('aria-invalid', 'false');
  }

  function syncConsentVisibility() {
    if (!consentPanel) return;
    const show = photos.length > 0;
    consentPanel.classList.toggle('is-visible', show);
    consentPanel.toggleAttribute('inert', !show);
    consentPanel.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (!show) clearConsentError();
  }

  function showConsentError() {
    if (consentError) consentError.hidden = false;
    consentInput?.setAttribute('aria-invalid', 'true');
    consentInput?.focus({ preventScroll: true });
    root.querySelector('[data-upload-step]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function recordConsent() {
    if (!consentInput?.checked) return;
    if (!photoConsent) {
      photoConsent = {
        consent_given_at: new Date().toISOString(),
        consent_version: consentInput.dataset.consentVersion || CONSENT_VERSION,
        consent_wording: consentWording(),
        session_id: session?.id || '',
      };
    } else if (session?.id) {
      photoConsent.session_id = session.id;
    }
    clearConsentError();
  }

  function isAllowedFile(file) {
    const type = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();
    return type === 'image/jpeg' || type === 'image/png' || /\.(jpe?g|png)$/.test(name);
  }

  function addFiles(list) {
    const incoming = [...list];
    let added = 0;
    for (const file of incoming) {
      if (photos.length >= maxPhotoCount()) {
        setStatus(`You can upload up to ${maxPhotoCount()} photos.`, true);
        break;
      }
      if (!isAllowedFile(file)) {
        setStatus('Use JPG or PNG photos.', true);
        continue;
      }
      if (file.size > MAX_BYTES) {
        setStatus(`${file.name} is over 10MB.`, true);
        continue;
      }
      photos.push({
        file,
        previewUrl: URL.createObjectURL(file),
        id: null,
        verdict: '',
        message: '',
        role: '',
        uploading: false,
        deleting: false,
      });
      added += 1;
    }
    renderPhotoThumbs();
    syncCheckoutState();
    if (!added) return;
    ensureSession().catch((error) => setStatus(error.message, true));
  }

  function renderPhotoThumbs() {
    if (photos.length >= MIN_PHOTOS) setUploadInvalid(false);
    if (!thumbs) return;
    thumbs.innerHTML = '';
    photos.forEach((photo, index) => {
      const item = document.createElement('div');
      item.className = 'create-page__photo-item';
      const shownVerdict = displayVerdict(photo);
      if (shownVerdict) item.dataset.verdict = shownVerdict;

      const wrap = document.createElement('div');
      wrap.className = 'create-page__photo-thumb';
      if (shownVerdict) wrap.dataset.verdict = shownVerdict;
      if (photo.uploading || photo.deleting) wrap.dataset.uploading = 'true';

      const img = document.createElement('img');
      img.src = photo.previewUrl;
      img.alt = photo.file.name;

      const slotBusy = Boolean(photo.uploading || photo.deleting);

      const crop = document.createElement('button');
      crop.type = 'button';
      crop.className = 'create-page__photo-crop';
      crop.textContent = 'Crop';
      crop.disabled = slotBusy;
      crop.addEventListener('click', (event) => {
        event.stopPropagation();
        if (photos[index]?.uploading || photos[index]?.deleting) return;
        openCrop(index);
      });

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'create-page__photo-remove';
      remove.setAttribute('aria-label', 'Remove photo');
      remove.textContent = '×';
      remove.hidden = !photo.id && photo.uploading;
      remove.disabled = slotBusy;
      remove.addEventListener('click', (event) => {
        event.stopPropagation();
        removePhoto(index);
      });

      wrap.append(img, crop, remove);
      if (photo.verdict === 'good') {
        const tick = document.createElement('span');
        tick.className = 'create-page__photo-tick';
        tick.innerHTML = CHECK_SVG;
        wrap.append(tick);
      }
      item.append(wrap);

      const feedbackCopy = photoFeedbackCopy(photo);
      if (feedbackCopy) {
        const message = document.createElement('p');
        message.className = 'create-page__photo-message';
        message.textContent = feedbackCopy;
        item.append(message);
      }
      if (!photo.id && photo.message && !slotBusy) {
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'create-page__photo-retry';
        retry.textContent = 'Retry';
        retry.addEventListener('click', (event) => {
          event.stopPropagation();
          retryPhoto(index);
        });
        item.append(retry);
      }

      thumbs.appendChild(item);
    });
    if (uploadCount) {
      const pendingLocal = photos.filter((item) => !item.id).length;
      const serverCount = session?.photo_count;
      uploadCount.textContent = String(
        serverCount != null ? Number(serverCount) + pendingLocal : photos.length
      );
    }
    const uploadMax = root.querySelector('[data-upload-max]');
    if (uploadMax) uploadMax.textContent = String(maxPhotoCount());
    syncConsentVisibility();
  }

  const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

  function imageRect() {
    const img = cropState.image;
    if (!img) return { x: 0, y: 0, w: 0, h: 0 };
    return {
      x: cropState.panX,
      y: cropState.panY,
      w: img.naturalWidth * cropState.scale,
      h: img.naturalHeight * cropState.scale,
    };
  }

  function stagePoint(event) {
    const rect = cropStage.getBoundingClientRect();
    return { x: event.clientX - rect.left, y: event.clientY - rect.top };
  }

  function minScaleForBox() {
    const img = cropState.image;
    if (!img) return 0.01;
    const { w, h } = cropState.box;
    const floor = Math.max(CROP_MIN_BOX / img.naturalWidth, CROP_MIN_BOX / img.naturalHeight);
    const coverBox = Math.max(w / img.naturalWidth, h / img.naturalHeight);
    return Math.max(cropState.fitScale * 0.5, floor, Math.min(coverBox, cropState.fitScale));
  }

  function clampBoxToImage() {
    const img = imageRect();
    const box = cropState.box;
    box.w = clamp(box.w, CROP_MIN_BOX, img.w);
    box.h = clamp(box.h, CROP_MIN_BOX, img.h);
    box.x = clamp(box.x, img.x, img.x + img.w - box.w);
    box.y = clamp(box.y, img.y, img.y + img.h - box.h);
  }

  function clampImageToCoverBox() {
    const img = cropState.image;
    if (!img) return;
    const box = cropState.box;
    const imgW = img.naturalWidth * cropState.scale;
    const imgH = img.naturalHeight * cropState.scale;
    if (imgW >= box.w) {
      cropState.panX = clamp(cropState.panX, box.x + box.w - imgW, box.x);
    } else {
      cropState.panX = box.x + (box.w - imgW) / 2;
      box.x = cropState.panX;
      box.w = imgW;
    }
    if (imgH >= box.h) {
      cropState.panY = clamp(cropState.panY, box.y + box.h - imgH, box.y);
    } else {
      cropState.panY = box.y + (box.h - imgH) / 2;
      box.y = cropState.panY;
      box.h = imgH;
    }
    clampBoxToImage();
  }

  function renderCrop() {
    const img = cropState.image;
    if (!cropImageEl || !cropBoxEl || !img) return;
    const w = img.naturalWidth * cropState.scale;
    const h = img.naturalHeight * cropState.scale;
    cropImageEl.style.width = `${w}px`;
    cropImageEl.style.height = `${h}px`;
    cropImageEl.style.transform = `translate(${cropState.panX}px, ${cropState.panY}px)`;
    cropBoxEl.style.left = `${cropState.box.x}px`;
    cropBoxEl.style.top = `${cropState.box.y}px`;
    cropBoxEl.style.width = `${cropState.box.w}px`;
    cropBoxEl.style.height = `${cropState.box.h}px`;
    cropBoxEl.hidden = false;
  }

  function resetCropView() {
    const img = cropState.image;
    if (!img || !cropStage) return;
    const sw = cropStage.clientWidth;
    const sh = cropStage.clientHeight;
    if (sw < 2 || sh < 2) return;
    const fit = Math.min((sw - CROP_PAD * 2) / img.naturalWidth, (sh - CROP_PAD * 2) / img.naturalHeight);
    cropState.fitScale = fit;
    cropState.scale = fit;
    cropState.panX = (sw - img.naturalWidth * fit) / 2;
    cropState.panY = (sh - img.naturalHeight * fit) / 2;
    const displayed = imageRect();
    const inset = 0.07;
    cropState.box = {
      x: displayed.x + displayed.w * inset,
      y: displayed.y + displayed.h * inset,
      w: displayed.w * (1 - inset * 2),
      h: displayed.h * (1 - inset * 2),
    };
    clampBoxToImage();
    cropState.needsFit = false;
    renderCrop();
  }

  function zoomAt(nextScale, origin) {
    const img = cropState.image;
    if (!img) return;
    const maxScale = cropState.fitScale * 8;
    const scale = clamp(nextScale, minScaleForBox(), maxScale);
    const k = scale / cropState.scale;
    cropState.panX = origin.x - (origin.x - cropState.panX) * k;
    cropState.panY = origin.y - (origin.y - cropState.panY) * k;
    cropState.scale = scale;
    clampImageToCoverBox();
    renderCrop();
  }

  function resizeBox(handle, dx, dy, start) {
    const img = imageRect();
    let { x, y, w, h } = start;
    if (handle.includes('e')) {
      w = clamp(start.w + dx, CROP_MIN_BOX, img.x + img.w - start.x);
    }
    if (handle.includes('s')) {
      h = clamp(start.h + dy, CROP_MIN_BOX, img.y + img.h - start.y);
    }
    if (handle.includes('w')) {
      w = clamp(start.w - dx, CROP_MIN_BOX, start.x + start.w - img.x);
      x = start.x + start.w - w;
    }
    if (handle.includes('n')) {
      h = clamp(start.h - dy, CROP_MIN_BOX, start.y + start.h - img.y);
      y = start.y + start.h - h;
    }
    cropState.box = { x, y, w, h };
    clampBoxToImage();
  }

  function releaseCropObjectUrl() {
    if (cropState.objectUrl) {
      URL.revokeObjectURL(cropState.objectUrl);
      cropState.objectUrl = '';
    }
  }

  async function openCrop(index) {
    const file = photos[index]?.file;
    if (!file || !cropDialog || !cropStage || !cropImageEl) return;
    releaseCropObjectUrl();
    const url = URL.createObjectURL(file);
    const image = new Image();
    image.src = url;
    try {
      await image.decode();
    } catch {
      setStatus('This photo cannot be cropped in the browser. Try a JPG or PNG.', true);
      URL.revokeObjectURL(url);
      return;
    }
    cropIndex = index;
    cropState.image = image;
    cropState.objectUrl = url;
    cropState.mode = 'none';
    cropState.needsFit = true;
    cropState.pointers.clear();
    cropImageEl.src = url;
    cropImageEl.alt = file.name || 'Photo';
    if (cropBoxEl) cropBoxEl.hidden = true;
    cropDialog.showModal();
    requestAnimationFrame(() => {
      requestAnimationFrame(resetCropView);
    });
  }

  function applyCrop() {
    const img = cropState.image;
    if (cropIndex < 0 || !img) return;
    const scale = cropState.scale;
    const box = cropState.box;
    let srcX = (box.x - cropState.panX) / scale;
    let srcY = (box.y - cropState.panY) / scale;
    let srcW = box.w / scale;
    let srcH = box.h / scale;
    srcX = clamp(srcX, 0, img.naturalWidth - 1);
    srcY = clamp(srcY, 0, img.naturalHeight - 1);
    srcW = clamp(srcW, 1, img.naturalWidth - srcX);
    srcH = clamp(srcH, 1, img.naturalHeight - srcY);
    const outScale = Math.min(1, CROP_MAX_EDGE / Math.max(srcW, srcH));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(srcW * outScale));
    canvas.height = Math.max(1, Math.round(srcH * outScale));
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(img, srcX, srcY, srcW, srcH, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(
      (blob) => {
        if (!blob) return;
        const photo = photos[cropIndex];
        if (!photo) return;
        const name = (photo.file?.name || 'photo.jpg').replace(/\.[^.]+$/, '.jpg');
        if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl);
        photo.file = new File([blob], name, { type: 'image/jpeg' });
        photo.previewUrl = URL.createObjectURL(photo.file);
        photo.verdict = '';
        photo.message = '';
        const replace = Boolean(photo.id);
        cropDialog?.close();
        renderPhotoThumbs();
        if (!selectedSubjectValue()) return;
        ensureSession()
          .then(() => uploadPhoto(photo, { replace }))
          .catch((error) => setStatus(error.message, true));
      },
      'image/jpeg',
      0.92
    );
  }

  function cropModeFromTarget(target) {
    const handle = target?.closest?.('[data-handle]');
    if (handle) return `resize-${handle.dataset.handle}`;
    if (target?.closest?.('[data-crop-box]')) return 'move-box';
    return 'pan-image';
  }

  function bindCropper() {
    if (!cropStage) return;

    cropImageEl?.addEventListener('dragstart', (event) => event.preventDefault());

    cropStage.addEventListener('pointerdown', (event) => {
      if (!cropState.image || event.button) return;
      event.preventDefault();
      cropStage.setPointerCapture(event.pointerId);
      const point = stagePoint(event);
      cropState.pointers.set(event.pointerId, point);
      if (cropState.pointers.size === 2) {
        const pts = [...cropState.pointers.values()];
        cropState.mode = 'pinch';
        cropState.pinchDist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        cropState.pinchScale = cropState.scale;
        return;
      }
      cropState.mode = cropModeFromTarget(event.target);
      cropState.lastX = event.clientX;
      cropState.lastY = event.clientY;
      cropState.startBox = { ...cropState.box };
      cropStage.classList.toggle('is-panning', cropState.mode === 'pan-image');
    });

    cropStage.addEventListener('pointermove', (event) => {
      if (!cropState.image || !cropState.pointers.has(event.pointerId)) return;
      const point = stagePoint(event);
      cropState.pointers.set(event.pointerId, point);
      if (cropState.mode === 'pinch' && cropState.pointers.size >= 2) {
        const pts = [...cropState.pointers.values()];
        const dist = Math.hypot(pts[0].x - pts[1].x, pts[0].y - pts[1].y);
        if (cropState.pinchDist > 0 && dist > 0) {
          const origin = { x: (pts[0].x + pts[1].x) / 2, y: (pts[0].y + pts[1].y) / 2 };
          zoomAt(cropState.pinchScale * (dist / cropState.pinchDist), origin);
        }
        return;
      }
      if (cropState.mode === 'none') return;
      const dx = event.clientX - cropState.lastX;
      const dy = event.clientY - cropState.lastY;
      cropState.lastX = event.clientX;
      cropState.lastY = event.clientY;
      if (cropState.mode === 'pan-image') {
        cropState.panX += dx;
        cropState.panY += dy;
        clampImageToCoverBox();
      } else if (cropState.mode === 'move-box') {
        const img = imageRect();
        const start = cropState.startBox;
        cropState.box.x = clamp(start.x + dx, img.x, img.x + img.w - start.w);
        cropState.box.y = clamp(start.y + dy, img.y, img.y + img.h - start.h);
        cropState.startBox = { ...cropState.box };
      } else if (cropState.mode.startsWith('resize-')) {
        resizeBox(cropState.mode.slice('resize-'.length), dx, dy, cropState.startBox);
        cropState.startBox = { ...cropState.box };
      }
      renderCrop();
    });

    const endPointer = (event) => {
      cropState.pointers.delete(event.pointerId);
      if (cropState.pointers.size < 2 && cropState.mode === 'pinch') {
        cropState.mode = 'none';
      }
      if (cropState.pointers.size === 0) {
        cropState.mode = 'none';
        cropStage.classList.remove('is-panning');
      }
    };
    cropStage.addEventListener('pointerup', endPointer);
    cropStage.addEventListener('pointercancel', endPointer);

    cropStage.addEventListener(
      'wheel',
      (event) => {
        if (!cropState.image) return;
        event.preventDefault();
        const factor = event.deltaY < 0 ? 1.08 : 1 / 1.08;
        zoomAt(cropState.scale * factor, stagePoint(event));
      },
      { passive: false }
    );

    cropDialog?.addEventListener('close', () => {
      cropIndex = -1;
      cropState.image = null;
      cropState.mode = 'none';
      cropState.needsFit = false;
      cropState.pointers.clear();
      cropStage.classList.remove('is-panning');
      if (cropImageEl) {
        cropImageEl.removeAttribute('src');
        cropImageEl.alt = '';
      }
      if (cropBoxEl) cropBoxEl.hidden = true;
      releaseCropObjectUrl();
    });

    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(() => {
        if (cropState.needsFit && cropState.image) resetCropView();
      }).observe(cropStage);
    }
  }

  function bindGallery() {
    root.querySelector('[data-thumbs-prev]')?.addEventListener('click', () => stepGallery(-1));
    root.querySelector('[data-thumbs-next]')?.addEventListener('click', () => stepGallery(1));
    if (galleryMain && typeof ResizeObserver === 'function') {
      new ResizeObserver(() => {
        if (!syncGalleryFrame()) return;
        const active = galleryThumbs?.querySelector('.create-page__thumb[aria-pressed="true"]');
        if (active) scrollThumbIntoView(active, { behavior: 'auto' });
      }).observe(galleryMain);
    }
    syncGalleryFrame();
  }

  function bindPackage() {
    root.querySelectorAll('[data-package-option]').forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) applyPackage(input.value);
      });
    });
  }

  function bindOptions() {
    root.querySelectorAll('[data-option-group]').forEach((group) => {
      group.querySelectorAll('[data-option]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-option]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
          button.setAttribute('aria-pressed', 'true');
          if (group.dataset.optionGroup === 'size') applySize(button.dataset.size);
          if (group.dataset.optionGroup === 'stand') {
            root.dataset.stand = mockupStandKey();
            refreshMockup();
          }
          if (group.dataset.optionGroup === 'subject') {
            subjectChosenByUser = true;
            setSubjectInvalid(false);
            ensureSession().catch((error) => setStatus(error.message, true));
          }
        });
      });
    });
  }

  function bindDialogs() {
    const photoGuideTrigger = root.querySelector('[data-open-dialog="photo-guide"]');
    const photoGuideDialog = root.querySelector('[data-dialog="photo-guide"]');

    root.querySelectorAll('[data-open-dialog]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector(`[data-dialog="${button.dataset.openDialog}"]`)?.showModal();
      });
    });
    photoGuideDialog?.addEventListener('close', () => {
      photoGuideTrigger?.focus();
    });
    root.querySelectorAll('[data-close-dialog]').forEach((button) => {
      button.addEventListener('click', () => button.closest('dialog')?.close());
    });
    root.querySelectorAll('dialog').forEach((dialog) => {
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    });
    bindCropper();
    root.querySelector('[data-crop-apply]')?.addEventListener('click', applyCrop);
  }

  function bindUpload() {
    const openPicker = () => {
      photosInput?.click();
    };
    dropzone?.addEventListener('click', openPicker);
    dropzone?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openPicker();
      }
    });
    dropzone?.addEventListener('dragover', (event) => {
      event.preventDefault();
      dropzone.classList.add('is-dragover');
    });
    dropzone?.addEventListener('dragleave', () => dropzone.classList.remove('is-dragover'));
    dropzone?.addEventListener('drop', (event) => {
      event.preventDefault();
      dropzone.classList.remove('is-dragover');
      addFiles(event.dataTransfer?.files || []);
    });
    photosInput?.addEventListener('change', () => {
      addFiles(photosInput.files || []);
      photosInput.value = '';
    });
    consentInput?.addEventListener('change', () => {
      if (!consentInput.checked) return;
      recordConsent();
      if (!photos.some((photo) => !photo.id && !photo.uploading)) return;
      ensureSession().catch((error) => setStatus(error.message, true));
    });
  }

  function hideBrokenStandImages() {
    root.querySelectorAll('.create-page__stand-media img').forEach((img) => {
      img.addEventListener('error', () => img.remove());
    });
  }

  function resetPhotoForNewSession(photo) {
    photo.id = null;
    photo.verdict = '';
    photo.message = '';
    photo.role = '';
    photo.gender = '';
    photo.detected_gender = '';
    photo.detected_subject = '';
    photo.uploading = false;
    photo.deleting = false;
  }

  function personOptionFromValue(value) {
    if (Array.isArray(value)) {
      const options = [...new Set(value.map(personOptionFromValue).filter(Boolean))];
      return options.length === 1 ? options[0] : '';
    }
    if (value && typeof value === 'object') {
      const score = (names) =>
        names.reduce((max, name) => {
          const raw = value[name] ?? value[name.charAt(0).toUpperCase() + name.slice(1)];
          const num = typeof raw === 'number' ? raw : NaN;
          return Number.isFinite(num) ? Math.max(max, num) : max;
        }, -1);
      const femaleScore = score(['female', 'woman', 'feminine']);
      const maleScore = score(['male', 'man', 'masculine']);
      if (femaleScore >= 0 || maleScore >= 0) {
        if (femaleScore === maleScore) return '';
        return femaleScore > maleScore ? 'Female' : 'Male';
      }
      return (
        personOptionFromValue(value.value) ||
        personOptionFromValue(value.Value) ||
        personOptionFromValue(value.label) ||
        personOptionFromValue(value.name) ||
        personOptionFromValue(value.gender) ||
        personOptionFromValue(value.Gender) ||
        ''
      );
    }
    const text = String(value || '')
      .toLowerCase()
      .replace(/[_-]+/g, ' ')
      .trim();
    if (!text) return '';
    const female = /\b(females?|women|woman|girls?|feminine)\b/.test(text) || text === 'f';
    const male = /\b(males?|men|man|boys?|masculine)\b/.test(text) || text === 'm';
    if (female === male) return '';
    return female ? 'Female' : 'Male';
  }

  function explicitPersonOption(source) {
    if (!source || typeof source !== 'object') return '';
    const options = [];
    const add = (value) => {
      const option = personOptionFromValue(value);
      if (option && !options.includes(option)) options.push(option);
    };
    const visit = (node, depth) => {
      if (!node || typeof node !== 'object' || depth > 4) return;
      if (Array.isArray(node)) {
        node.forEach((item) => {
          if (item && typeof item === 'object') visit(item, depth + 1);
          else add(item);
        });
        return;
      }
      for (const [key, value] of Object.entries(node)) {
        if (/gender|(^|_)sex$/i.test(key)) add(value);
        else if (
          value &&
          typeof value === 'object' &&
          /gender|sex|analysis|attribute|face|label|detection|insight/i.test(key)
        ) {
          visit(value, depth + 1);
        }
      }
    };
    visit(source, 0);
    return options.length === 1 ? options[0] : '';
  }

  function assignDetection(photo, remote) {
    if (!photo || !remote) return;
    const explicit = explicitPersonOption(remote);
    if (explicit) {
      photo.gender = explicit;
      photo.detected_gender = explicit;
      photo.detected_subject = '';
      return;
    }
    if (remote.detected_subject) photo.detected_subject = remote.detected_subject;
    else if (remote.subject) photo.detected_subject = remote.subject;
  }

  function agreedPersonOption() {
    const fromPhotos = photos
      .map((photo) => personOptionFromValue(photo.gender) || personOptionFromValue(photo.detected_gender))
      .filter(Boolean);
    if (fromPhotos.length) {
      return fromPhotos.every((option) => option === fromPhotos[0]) ? fromPhotos[0] : '';
    }
    if (!photos.some((photo) => photo.id)) return '';
    const sessionGender = personOptionFromValue(session?.detected_gender);
    if (sessionGender) return sessionGender;
    const subjects = photos.map((photo) => personOptionFromValue(photo.detected_subject)).filter(Boolean);
    if (subjects.length) {
      return subjects.every((option) => option === subjects[0]) ? subjects[0] : '';
    }
    return personOptionFromValue(session?.detected_subject);
  }

  function selectSubjectOption(option) {
    const group = subjectStep?.querySelector('[data-option-group="subject"]');
    if (!group) return;
    group.querySelectorAll('[data-option]').forEach((button) => {
      button.setAttribute('aria-pressed', button.dataset.option === option ? 'true' : 'false');
    });
    setSubjectInvalid(false);
  }

  function applyDetectedSubject() {}

  function samePhotoId(left, right) {
    return left != null && right != null && String(left) === String(right);
  }

  function dropLocalPhoto(photo) {
    const index = photos.indexOf(photo);
    if (photo?.previewUrl) URL.revokeObjectURL(photo.previewUrl);
    if (index >= 0) photos.splice(index, 1);
  }

  function applySessionPayload(data, { preset, subject, consentRecorded } = {}) {
    data = unwrapPayload(data);
    if (!data) return;
    const previous = session;
    const apiMax = Number(data.max_photos);
    session = {
      id: data.id || previous?.id || '',
      preset: preset || previous?.preset || selectedPreset(),
      subject: subject || previous?.subject || selectedSubjectValue(),
      ready_for_checkout: Boolean(data.ready_for_checkout),
      blocking_reason: data.blocking_reason || '',
      min_photos: Number(data.min_photos) > 0 ? Number(data.min_photos) : MIN_PHOTOS,
      max_photos: apiMax > 0 ? Math.min(apiMax, MAX_PHOTOS) : MAX_PHOTOS,
      photo_count:
        data.photo_count != null ? Number(data.photo_count) : photos.filter((photo) => photo.id).length,
      consent_recorded:
        consentRecorded != null ? Boolean(consentRecorded) : Boolean(previous?.consent_recorded),
      detected_gender: explicitPersonOption(data) || previous?.detected_gender || '',
      detected_subject:
        data.detected_subject ||
        (photos.some((photo) => photo.id) && !subject ? data.subject : '') ||
        previous?.detected_subject ||
        '',
    };
    if (photoConsent && session.id) photoConsent.session_id = session.id;

    if (Array.isArray(data.photos)) {
      data.photos.forEach((remote) => {
        const local = photos.find((photo) => samePhotoId(photo.id, remote.id));
        if (!local) return;
        local.verdict = remote.verdict || local.verdict;
        local.message = remote.message || '';
        local.role = remote.role || local.role;
        assignDetection(local, remote);
      });
    }

    renderPhotoThumbs();
    applyDetectedSubject();
    syncCheckoutState();
  }

  function uploadSnapshot() {
    const total = photos.length;
    const uploaded = photos.filter((photo) => photo.id).length;
    const activeIndex = photos.findIndex((photo) => photo.uploading);
    const uploading = activeIndex >= 0 || photos.some((photo) => photo.uploading);
    const current = activeIndex >= 0 ? activeIndex + 1 : Math.min(uploaded + 1, total);
    return { total, uploaded, uploading, current };
  }

  function failedUpload() {
    return photos.find((photo) => !photo.id && photo.message && !photo.uploading && !photo.deleting);
  }

  function cartProblemMessage() {
    if (photos.some((photo) => photo.uploading || photo.deleting)) return '';
    const failed = failedUpload();
    if (failed) return failed.message;
    if (photos.length < MIN_PHOTOS || photos.some((photo) => !photo.id)) return '';
    return photoCheckoutMessage();
  }

  function renderUploadProgress() {
    const box = root.querySelector('[data-upload-progress]');
    const label = root.querySelector('[data-upload-progress-label]');
    const track = root.querySelector('[data-upload-progress-track]');
    const fill = root.querySelector('[data-upload-progress-fill]');
    const { total, uploaded, uploading, current } = uploadSnapshot();
    const show = uploading && total > 0;
    if (box) box.hidden = !show;
    if (!show) return;
    const percent = Math.round((uploaded / total) * 100);
    const count = root.querySelector('[data-upload-progress-count]');
    const spoken = `Uploading photo ${current} of ${total}`;
    if (label) label.textContent = spoken;
    if (count) count.textContent = `${current} / ${total}`;
    if (box) box.classList.toggle('is-starting', percent === 0);
    if (fill) fill.style.width = `${percent === 0 ? 18 : percent}%`;
    if (track) {
      track.setAttribute('aria-valuenow', String(percent));
      track.setAttribute('aria-valuetext', spoken);
    }
  }

  function returnToUploadStep() {
    document.querySelector('theme-drawer#cart-drawer')?.close?.();
    root.querySelector('[data-upload-step]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function cartUploadHost() {
    return (
      document.querySelector('#cart-drawer .cart-drawer__scroll') ||
      document.querySelector('#cart-drawer .cart-drawer__content') ||
      document.querySelector('#cart-drawer [data-hydration-key="cart-drawer-inner"]')
    );
  }

  function ensureCartUploadBox(host) {
    let box = host.querySelector('[data-cart-upload-progress]');
    if (box) return box;
    box = document.createElement('div');
    box.className = 'create-page__upload-card create-page__cart-upload';
    box.dataset.cartUploadProgress = '';
    box.hidden = true;

    const head = document.createElement('div');
    head.className = 'create-page__upload-card-head';
    head.dataset.cartUploadHead = '';

    const kicker = document.createElement('span');
    kicker.className = 'create-page__upload-card-kicker';
    const dot = document.createElement('span');
    dot.className = 'create-page__upload-card-dot';
    dot.setAttribute('aria-hidden', 'true');
    kicker.append(dot, document.createTextNode('Uploading'));

    const count = document.createElement('span');
    count.className = 'create-page__upload-card-count';
    count.dataset.cartUploadCount = '';
    head.append(kicker, count);

    const label = document.createElement('p');
    label.className = 'create-page__cart-upload-label visually-hidden';
    label.dataset.cartUploadLabel = '';

    const track = document.createElement('div');
    track.className = 'create-page__upload-progress-track';
    track.dataset.cartUploadTrack = '';
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    track.setAttribute('aria-valuenow', '0');
    const fill = document.createElement('span');
    fill.className = 'create-page__upload-progress-fill';
    fill.dataset.cartUploadFill = '';
    track.append(fill);

    const fix = document.createElement('button');
    fix.type = 'button';
    fix.className = 'create-page__cart-upload-fix';
    fix.dataset.cartUploadFix = '';
    fix.textContent = 'Fix photos';
    fix.hidden = true;
    fix.addEventListener('click', returnToUploadStep);

    box.append(head, label, track, fix);
    host.prepend(box);
    return box;
  }

  function renderCartUploadProgress() {
    const host = cartUploadHost();
    if (!host) return;
    const box = ensureCartUploadBox(host);
    const label = box.querySelector('[data-cart-upload-label]');
    const count = box.querySelector('[data-cart-upload-count]');
    const track = box.querySelector('[data-cart-upload-track]');
    const fill = box.querySelector('[data-cart-upload-fill]');
    const fix = box.querySelector('[data-cart-upload-fix]');
    const { total, uploaded, uploading, current } = uploadSnapshot();
    const problem = cartProblemMessage();

    if (uploading && total > 0) {
      const percent = Math.round((uploaded / total) * 100);
      const spoken = `Uploading photo ${current} of ${total}`;
      box.hidden = false;
      box.classList.remove('is-error');
      box.classList.toggle('is-starting', percent === 0);
      if (label) {
        label.textContent = spoken;
        label.classList.add('visually-hidden');
      }
      if (count) count.textContent = `${current} / ${total}`;
      if (track) {
        track.hidden = false;
        track.setAttribute('aria-valuenow', String(percent));
        track.setAttribute('aria-valuetext', spoken);
      }
      if (fill) fill.style.width = `${percent === 0 ? 18 : percent}%`;
      if (fix) fix.hidden = true;
      return;
    }

    if (problem) {
      box.hidden = false;
      box.classList.add('is-error');
      box.classList.remove('is-starting');
      if (label) {
        label.textContent = problem;
        label.classList.remove('visually-hidden');
      }
      if (track) track.hidden = true;
      if (fix) fix.hidden = false;
      return;
    }

    box.hidden = true;
    box.classList.remove('is-error');
  }

  function syncCheckoutState(progressText = '') {
    syncAddButton();
    renderUploadProgress();
    renderCartUploadProgress();

    if (progressText) {
      setStatus(progressText);
      return;
    }
    if (checkoutBusy || sessionBusy) return;
    if (photos.some((photo) => photo.uploading || photo.deleting)) {
      if (!failedUpload() && statusEl?.classList.contains('create-page__status--error')) setStatus('');
      return;
    }
    if (!photos.length) {
      if (statusIsPhotoFeedback()) setStatus('');
      return;
    }
    if (!selectedSubjectValue()) {
      if (statusIsPhotoFeedback()) setStatus('');
      return;
    }
    const issue = photoCheckoutMessage();
    if (issue === `Upload ${MIN_PHOTOS}–${MAX_PHOTOS} photos.`) {
      if (statusEl?.textContent === issue) setStatus('');
      return;
    }
    if (issue) {
      setStatus(issue, true);
      return;
    }
    const failed = failedUpload();
    if (failed) {
      setStatus(failed.message, true);
      return;
    }
    if (photos.some((photo) => !photo.id)) return;
    const note = photoAdvisoryNote();
    const keptStatus = 'Added to cart. Your portraits will be generated after checkout.';
    if (note) {
      if (statusEl?.textContent !== keptStatus) setStatus(note, false);
      return;
    }
    if (
      statusIsPhotoFeedback() ||
      statusEl?.textContent === 'Creating upload session…' ||
      statusEl?.textContent === 'Preparing photo upload…'
    ) {
      setStatus('');
    }
  }

  async function patchSessionSubject(subject) {
    if (!session?.id || !subject || session.subject === subject) return true;
    if (subjectPatchFlight) {
      const previous = await subjectPatchFlight;
      if (!session?.id || session.subject === subject) return true;
      if (previous === false) return false;
    }

    const preset = session.preset;
    const consentRecorded = session.consent_recorded;
    subjectPatchFlight = jsonFetch('/api/generation-sessions/' + session.id, {
      method: 'PATCH',
      body: JSON.stringify({ subject }),
    })
      .then((data) => {
        applySessionPayload(data, { preset, subject, consentRecorded });
        return true;
      })
      .catch((error) => {
        const unsupported = error.status === 404 || error.status === 405 || error.status === 501;
        if (unsupported) return false;
        throw error;
      })
      .finally(() => {
        subjectPatchFlight = null;
      });
    return subjectPatchFlight;
  }

  async function patchSessionPreset(preset) {
    if (!session?.id || !preset || session.preset === preset) return true;
    if (presetPatchFlight) {
      const previous = await presetPatchFlight;
      if (!session?.id || session.preset === preset) return true;
      if (previous === false) return false;
    }

    const subject = session.subject;
    const consentRecorded = session.consent_recorded;
    presetPatchFlight = jsonFetch('/api/generation-sessions/' + session.id, {
      method: 'PATCH',
      body: JSON.stringify({ preset }),
    })
      .then((data) => {
        applySessionPayload(data, { preset, subject, consentRecorded });
        return true;
      })
      .catch((error) => {
        const unsupported = error.status === 404 || error.status === 405 || error.status === 501;
        if (unsupported) return false;
        throw error;
      })
      .finally(() => {
        presetPatchFlight = null;
      });
    return presetPatchFlight;
  }

  async function ensureSession() {
    const preset = selectedPreset();
    const subject = selectedSubjectValue();
    if (!apiBase || !storeKey) throw customerError(new Error('Generation is not configured.'));
    if (!preset || !presetIsAvailable(preset)) {
      throw new Error('Choose a firefighter first.');
    }

    if (sessionInFlight && String(sessionInFlightKey).startsWith(`${preset}|`)) {
      await sessionInFlight;
    }

    const consent = hasUploadConsent() ? consentPayload() : null;
    const samePreset = Boolean(session?.id && session.preset === preset);
    const needsConsentOnSession = Boolean(
      consent &&
        samePreset &&
        session.subject === subject &&
        !session.consent_recorded &&
        !uploadsRunning &&
        !photos.some((photo) => photo.id || photo.uploading)
    );
    if (samePreset && !needsConsentOnSession) {
      const subjectSaved = !subject || session.subject === subject || (await patchSessionSubject(subject));
      if (subjectSaved) {
        if (photoConsent && session?.id) photoConsent.session_id = session.id;
        startPendingUploads();
        syncCheckoutState();
        return session;
      }
    }

    if (session?.id && session.preset !== preset) {
      let presetSaved = await patchSessionPreset(preset);
      if (!presetSaved && photos.some((photo) => photo.id || photo.file || photo.uploading)) {
        session.preset = preset;
        presetSaved = true;
      }
      if (presetSaved) {
        const subjectSaved = !subject || session.subject === subject || (await patchSessionSubject(subject));
        if (subjectSaved) {
          if (photoConsent && session?.id) photoConsent.session_id = session.id;
          startPendingUploads();
          syncCheckoutState();
          return session;
        }
      }
    }

    const key = `${preset}|${subject}`;
    if (sessionInFlight && sessionInFlightKey === key) return sessionInFlight;

    const requestId = ++sessionRequest;
    sessionInFlightKey = key;
    sessionBusy = true;
    syncCheckoutState(subject ? 'Creating upload session…' : 'Preparing photo upload…');
    const flight = (async () => {
      try {
        const body = { preset };
        if (subject) body.subject = subject;
        if (consent) body.photo_consent = consent;
        let data;
        try {
          data = await jsonFetch('/api/generation-sessions', {
            method: 'POST',
            body: JSON.stringify(body),
          });
        } catch (error) {
          if (!subject && (error.status === 400 || error.status === 422)) return null;
          throw error;
        }
        if (requestId !== sessionRequest) return session;

        photos.forEach(resetPhotoForNewSession);
        session = null;
        applySessionPayload(data, { preset, subject, consentRecorded: Boolean(consent) });
        startPendingUploads();
        return session;
      } finally {
        if (sessionInFlight === flight) sessionInFlight = null;
        if (requestId === sessionRequest) {
          sessionBusy = false;
          syncCheckoutState();
        }
      }
    })();
    sessionInFlight = flight;
    return flight;
  }

  function applyPhotoResponse(photo, data) {
    data = unwrapPayload(data);
    const remote = data.photo || {};
    photo.id = remote.id || photo.id;
    photo.verdict = remote.verdict || '';
    photo.message = remote.message || '';
    photo.role = remote.role || '';
    assignDetection(photo, remote);
    photo.uploading = false;
    applySessionPayload(data);
  }

  async function uploadPhoto(photo, { replace = false } = {}) {
    if (!session?.id) throw new Error('Choose a firefighter and subject first.');
    if (!isAllowedFile(photo.file)) throw new Error('Use JPG or PNG photos.');
    if (photo.file.size > MAX_BYTES) throw new Error(`${photo.file.name} is over 10MB.`);

    photo.uploading = true;
    renderPhotoThumbs();
    syncCheckoutState();

    const body = new FormData();
    body.append('image', photo.file);
    const path =
      replace && photo.id
        ? '/api/generation-sessions/' + session.id + '/photos/' + photo.id
        : '/api/generation-sessions/' + session.id + '/photos';

    try {
      const data = await jsonFetch(path, { method: 'POST', body });
      applyPhotoResponse(photo, data);
    } catch (error) {
      photo.uploading = false;
      photo.message = error.message;
      renderPhotoThumbs();
      syncCheckoutState();
      throw error;
    }
  }

  function startPendingUploads() {
    if (uploadsRunning) return;
    if (!photos.some((photo) => !photo.id && !photo.message && !photo.uploading)) return;
    uploadPendingPhotos().catch((error) => {
      setStatus(error.message, true);
      syncCheckoutState();
    });
  }

  async function uploadPendingPhotos() {
    if (uploadsRunning) return;
    uploadsRunning = true;
    const generation = ++uploadGeneration;
    try {
      for (const photo of photos) {
        if (generation !== uploadGeneration) return;
        if (photo.id || photo.message || photo.uploading) continue;
        try {
          await uploadPhoto(photo);
        } catch (error) {
          if (generation !== uploadGeneration) return;
          setStatus(error.message, true);
        }
      }
    } finally {
      if (generation === uploadGeneration) uploadsRunning = false;
      syncCheckoutState();
    }
  }

  async function retryPhoto(index) {
    const photo = photos[index];
    if (!photo || photo.id || photo.deleting) return;
    photo.message = '';
    photo.uploading = true;
    renderPhotoThumbs();
    try {
      if (!session?.id) await ensureSession();
      photo.uploading = false;
      if (!photo.id) await uploadPhoto(photo);
    } catch (error) {
      console.error(error);
      photo.uploading = false;
      if (!photo.message) photo.message = error.message || CUSTOMER_ERROR;
      setStatus(error.network ? CUSTOMER_ERROR : error.message || CUSTOMER_ERROR, true);
      renderPhotoThumbs();
    }
    syncCheckoutState();
  }

  async function removePhoto(index) {
    const photo = photos[index];
    if (!photo || photo.uploading || photo.deleting) return;

    if (!photo.id || !session?.id) {
      dropLocalPhoto(photo);
      renderPhotoThumbs();
      syncCheckoutState();
      return;
    }

    const photoId = photo.id;
    photo.deleting = true;
    renderPhotoThumbs();
    syncCheckoutState();

    try {
      const data = await jsonFetch(
        '/api/generation-sessions/' + session.id + '/photos/' + photoId,
        { method: 'DELETE' }
      );
      dropLocalPhoto(photo);
      applySessionPayload(data);
    } catch (error) {
      if (error.status === 404) {
        dropLocalPhoto(photo);
        try {
          await refreshSession();
        } catch {
          renderPhotoThumbs();
          syncCheckoutState();
        }
        return;
      }
      if (error.network || error instanceof TypeError) {
        console.error(error);
        dropLocalPhoto(photo);
        session = null;
        renderPhotoThumbs();
        setStatus(CUSTOMER_ERROR, true);
        syncCheckoutState();
        return;
      }
      photo.deleting = false;
      renderPhotoThumbs();
      if (error.status === 409) {
        setStatus(error.message, true);
        syncCheckoutState();
        return;
      }
      setStatus('Could not remove that photo. Please try again.', true);
      syncCheckoutState();
    }
  }

  async function refreshSession() {
    if (!session?.id) return null;
    const data = await jsonFetch('/api/generation-sessions/' + session.id);
    applySessionPayload(data);
    return session;
  }

  async function fetchCartDrawerSectionHtml() {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', 'cart-drawer-section');
    const response = await fetch(url.toString(), {
      headers: { Accept: 'text/html' },
      credentials: 'same-origin',
    });
    if (!response.ok) return '';
    return response.text();
  }

  function withCartDrawerSectionWrapper(html) {
    if (!html) return '';
    if (html.includes('shopify-section-cart-drawer-section')) return html;
    return `<div id="shopify-section-cart-drawer-section" class="shopify-section">${html}</div>`;
  }

  function applyCartDrawerHtml(html) {
    const wrapped = withCartDrawerSectionWrapper(html);
    const doc = new DOMParser().parseFromString(wrapped, 'text/html');
    const newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
    const oldInner = document.querySelector(
      '#shopify-section-cart-drawer-section [data-hydration-key="cart-drawer-inner"]'
    );
    if (!oldInner || !newInner) return false;
    oldInner.replaceWith(newInner);
    return true;
  }

  async function upgradeCartDrawer(rootNode) {
    if (!(rootNode instanceof Element)) return;
    const scripts = [
      'component-cart-items.js',
      'component-cart-quantity-selector.js',
      'cart-drawer.js',
      'cart-stand-upsell.js',
    ];
    await Promise.all(
      scripts.map(async (name) => {
        const src = document.querySelector(`script[src*="${name}"]`)?.src;
        if (!src) return;
        try {
          await import(src);
        } catch (error) {
          console.error(error);
        }
      })
    );
    await Promise.all(
      ['cart-items-component', 'cart-quantity-selector-component', 'cart-drawer-component', 'cart-stand-upsell'].map((tag) =>
        Promise.race([
          customElements.whenDefined(tag),
          new Promise((resolve) => {
            setTimeout(resolve, 3000);
          }),
        ])
      )
    );
    const upgrade = (node) => {
      if (node instanceof Element) customElements.upgrade(node);
    };
    upgrade(rootNode);
    rootNode.querySelectorAll('*').forEach(upgrade);
  }

  async function refreshCartDrawer(sectionsHtml) {
    let html = sectionsHtml?.['cart-drawer-section'] || '';
    if (!html) {
      html = await fetchCartDrawerSectionHtml();
    }

    let painted = applyCartDrawerHtml(html);
    if (!painted) {
      html = await fetchCartDrawerSectionHtml();
      painted = applyCartDrawerHtml(html);
    }
    if (painted) {
      const inner = document.querySelector(
        '#shopify-section-cart-drawer-section [data-hydration-key="cart-drawer-inner"]'
      );
      if (inner) await upgradeCartDrawer(inner);
    }

    let cart = {};
    try {
      const cartUrl = (routes.cart_url || '/cart') + '.js';
      const cartResponse = await fetch(cartUrl, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      if (cartResponse.ok) cart = await cartResponse.json();
    } catch (error) {
      console.warn('Cart count could not be refreshed', error);
    }

    try {
      const { CartLinesUpdateEvent } = await import('@shopify/events');
      const deferredUpdatePromise = CartLinesUpdateEvent.createPromise();
      document.dispatchEvent(
        new CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [],
          promise: deferredUpdatePromise.promise,
        })
      );
      deferredUpdatePromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          itemCount: cart.item_count,
          items: cart.items,
          source: 'create-your-own',
          didError: false,
        },
      });
    } catch (error) {
      console.warn('Cart icon could not be notified', error);
    }

    renderCartUploadProgress();
    const openDrawer = () => document.querySelector('theme-drawer#cart-drawer')?.open?.();
    if (customElements.get('theme-drawer')) openDrawer();
    else customElements.whenDefined('theme-drawer').then(openDrawer);
  }

  function activePreviewImage() {
    const active =
      galleryThumbs?.querySelector('.create-page__thumb[aria-pressed="true"]') ||
      galleryThumbs?.querySelector('.create-page__thumb');
    const src = active?.dataset.src || '';
    if (!src) return '';
    const file = decodeURIComponent(src.split('?')[0].split('/').pop() || '');
    if (/^gallery-[a-z0-9._-]+\.(jpe?g|png|webp)$/i.test(file)) return file;
    if (src.length <= 240 && /^https:\/\//i.test(src)) return src;
    return '';
  }

  function resetCheckoutDraft() {
    sessionRequest += 1;
    sessionInFlight = null;
    sessionInFlightKey = '';
    session = null;
    photos.forEach((photo) => {
      if (photo.previewUrl) URL.revokeObjectURL(photo.previewUrl);
    });
    photos = [];
    if (photoConsent) photoConsent.session_id = '';
    renderPhotoThumbs();
  }

  async function readCartAddResponse(response) {
    const raw = await response.text();
    let data = null;
    try {
      data = raw ? JSON.parse(raw) : null;
    } catch (error) {
      console.error('cart/add.js returned a non-JSON body', response.status, raw);
      data = null;
    }
    const contentType = response.headers.get('content-type') || '';
    if (response.status === 401 || data == null || contentType.includes('text/html')) {
      console.error('cart/add.js rejected', response.status, raw);
      throw new Error(
        'The store is password protected right now, so the cart is unavailable. Please try again once the store is open.'
      );
    }
    const reportedStatus = Number(data.status);
    if (!response.ok || (Number.isFinite(reportedStatus) && reportedStatus >= 400)) {
      console.error('cart/add.js failed', {
        status: response.status,
        body: data,
      });
      const error = new Error(data.description || data.message || 'Could not add to cart.');
      error.status = response.status;
      error.body = data;
      throw error;
    }
    return data;
  }

  async function postCartAdd(items) {
    const payload = {
      items: items.map((item) => ({
        id: item.id,
        quantity: item.quantity,
        properties: item.properties,
        ...(item.parent_id ? { parent_id: item.parent_id } : {}),
        ...(item.parent_line_key ? { parent_line_key: item.parent_line_key } : {}),
      })),
      sections: 'cart-drawer-section',
      sections_url: window.location.pathname,
    };
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(payload),
    });
    return readCartAddResponse(response);
  }

  async function postCartAddWithPhoto(item, photoFile) {
    const body = new FormData();
    body.append('id', String(item.id));
    body.append('quantity', String(item.quantity || 1));
    Object.entries(item.properties || {}).forEach(([key, value]) => {
      if (value == null || value === '') return;
      body.append(`properties[${key}]`, String(value));
    });
    body.append('properties[_customer_photo]', photoFile, 'photo.jpg');
    body.append('sections', 'cart-drawer-section');
    body.append('sections_url', window.location.pathname);
    const response = await fetch(cartAddUrl, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });
    return readCartAddResponse(response);
  }

  async function addToCart(items, photoFile) {
    const [parentItem, standItem] = items;
    let data;
    if (photoFile) {
      try {
        data = await postCartAddWithPhoto(parentItem, photoFile);
      } catch (error) {
        console.warn('Customer photo could not be attached', error);
        photoFile = null;
      }
    }
    if (!photoFile) {
      const payload = [parentItem];
      if (standItem?.id) {
        payload.push({
          ...standItem,
          parent_id: parentItem.id,
        });
      }
      data = await postCartAdd(payload);
    } else if (standItem?.id) {
      const parentKey = data.key || data.items?.[0]?.key;
      const standPayload = parentKey
        ? { ...standItem, parent_line_key: parentKey }
        : { ...standItem, parent_id: parentItem.id };
      try {
        const standData = await postCartAdd([standPayload]);
        data = standData;
      } catch (error) {
        console.warn('Stand could not be added with the print', error);
      }
    }
    await refreshCartDrawer(data.sections);
    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  addButton?.addEventListener('click', async () => {
    if (checkoutBusy) return;
    if (!selectedSubjectValue()) {
      setSubjectInvalid(true);
      return;
    }
    setSubjectInvalid(false);
    if (photos.length < MIN_PHOTOS) {
      setUploadInvalid(true);
      return;
    }
    setUploadInvalid(false);
    const failed = failedUpload();
    if (failed) {
      setStatus(failed.message, true);
      uploadStep?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
    if (!hasUploadConsent()) {
      showConsentError();
      return;
    }

    checkoutBusy = true;
    syncCheckoutState();
    try {
      const digital = selectedPackage() === 'digital';
      const digitalProduct = catalog.digital;
      const sizeKey = selectedSize();
      const size = catalog.sizes?.[sizeKey];
      const standKey = digital || size?.stands === false ? 'none' : selectedStand();
      pressStand(standKey);
      const stand = catalog.stands?.[standKey];
      const preset = selectedPreset();

      if (!apiBase || !storeKey) {
        throw customerError(new Error('Generation is not configured.'));
      }
      if (!preset) throw new Error('Choose a firefighter first.');
      if (!presetIsAvailable(preset)) {
        throw new Error('This firefighter is not available for generation yet.');
      }
      if (digital) {
        if (!digitalProduct?.id || digitalProduct.requiresShipping) {
          console.error('Digital Only cannot be added', digitalProduct || null);
          checkoutBusy = false;
          syncAddButton();
          setStatus(DIGITAL_UNAVAILABLE, true);
          return;
        }
      } else if (!size?.id) {
        throw customerError(new Error('This print size is not linked in Theme settings.'));
      }
      if (standKey !== 'none' && !stand?.id) {
        throw customerError(new Error('This stand is not linked in Theme settings.'));
      }

      const failed = failedUpload();
      if (failed) {
        throw new Error(failed.message || 'One photo could not be uploaded. Remove it or try again.');
      }

      await ensureSession();
      if (!session?.id) throw new Error('Choose a firefighter and subject first.');

      const properties = {
        _generation_preset: preset,
        _training_session: session.id,
        _consent_given_at: photoConsent.consent_given_at,
        _consent_version: photoConsent.consent_version,
        _consent_wording: photoConsent.consent_wording,
        Subject: selectedSubject(),
        Firefighter: selectedFirefighterName() || preset,
        Package: digital ? 'Digital only' : 'Digital + print',
        _fulfilment: digital ? 'DIGITAL_ONLY' : 'DIGITAL_PLUS_PRINT',
      };
      const previewImage = activePreviewImage();
      if (previewImage) properties._preview_image = previewImage;
      const customerPhoto = await customerPhotoFile();

      const qty = quantity();
      const lineGroup =
        (window.crypto && typeof crypto.randomUUID === 'function' && crypto.randomUUID()) || `line-${Date.now()}`;
      properties._line_group = lineGroup;
      const items = [{ id: digital ? digitalOffer().id : size.id, quantity: qty, properties }];
      if (!digital && standKey !== 'none' && stand?.id) {
        items.push({
          id: stand.id,
          quantity: qty,
          properties: {
            Size: sizeKey.toUpperCase(),
            _line_group: lineGroup,
          },
        });
      }

      syncCheckoutState('Adding to cart…');
      await addToCart(items, customerPhoto);
      resetCheckoutDraft();
      checkoutBusy = false;
      setStatus('Added to cart. Your portraits will be generated after checkout.');
      syncCheckoutState();
    } catch (error) {
      checkoutBusy = false;
      syncCheckoutState();
      setStatus(checkoutStatusMessage(error), true);
      if (failedUpload()) {
        root.querySelector('[data-upload-step]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  });

  hideBrokenStandImages();
  bindFirefighterClicks();
  bindGallery();
  bindPackage();
  bindOptions();
  bindDialogs();
  bindUpload();
  applyPackage(selectedPackage());
  showGallery(selectedPreset() || GENERATION_PRESET);
  applyAvailablePresets();
  syncCheckoutState();
  loadPresets().catch((error) => setStatus(error.message, true));
})();
